export default "__VITE_ASSET__Bhsg4UUM__"